import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { tabs } from "../../constants";

interface WorkflowsBannerProps {
  hide: boolean;
  setActiveTab: (tab: string) => void;
}

export const WorkflowsBanner = ({
  setActiveTab,
  hide,
}: WorkflowsBannerProps) => {
  const onClickCreateWorkflow = () => {
    setActiveTab(tabs.WORKFLOWS_TAB);
  };

  if (hide) {
    return null;
  }

  return (
    <div className="bg-tertiary flex items-start rounded-md p-4">
      <div className="shrink-0">
        <Icon type="20-lightning" size={20} />
      </div>
      <div className="ml-3">
        <Typography.BodyMd>
          {t(
            "settings.paywalls.modal.tabs.post_purchase.workflows_banner.title",
          )}
        </Typography.BodyMd>
        <div className="mt-2">
          <Typography.BodySm color="text-light">
            {t(
              "settings.paywalls.modal.tabs.post_purchase.workflows_banner.description",
            )}
          </Typography.BodySm>
        </div>
        <div className="mt-2">
          <Button small variant="secondary" onClick={onClickCreateWorkflow}>
            {t(
              "settings.paywalls.modal.tabs.post_purchase.workflows_banner.button",
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};
